// フォルダ行/動画行を表示順で連結したshift範囲選択（アンカー管理・範囲計算）
import { ref, computed, watch } from 'vue';
import { isFolderItem, itemKey } from './useItemTypeGuards';

export const useUnifiedRangeSelect = ({
  items,
  getFolderPath,
  selectedItem,
  selectedFolderId,
  isFolderAllowed,
}) => {
  const wrapFolder = (f) => ({
    item_type: 'folder',
    id: f.id,
    name: f.name,
    folder_path: getFolderPath(f.id),
  });

  const unifiedRows = computed(() =>
    (items.value || []).map((row) => (isFolderItem(row) ? wrapFolder(row) : row))
  );

  const anchorKey = ref(null);

  const setAnchorFromItem = (item) => {
    anchorKey.value = item ? itemKey(item) : null;
  };

  const computeShiftRange = (clickedRow) => {
    const rows = unifiedRows.value;
    const clickedKey = itemKey(clickedRow);
    const clickedIndex = rows.findIndex((row) => itemKey(row) === clickedKey);
    if (clickedIndex === -1) {
      return [clickedRow];
    }

    let anchorIndex = anchorKey.value
      ? rows.findIndex((row) => itemKey(row) === anchorKey.value)
      : -1;
    if (anchorIndex === -1 && selectedItem.value) {
      const selKey = itemKey(selectedItem.value);
      anchorIndex = rows.findIndex((row) => itemKey(row) === selKey);
    }
    if (anchorIndex === -1) {
      anchorIndex = clickedIndex;
    }

    const start = Math.min(anchorIndex, clickedIndex);
    const end = Math.max(anchorIndex, clickedIndex);
    return rows
      .slice(start, end + 1)
      .filter((row) => !isFolderItem(row) || isFolderAllowed(row.id));
  };

  watch(selectedFolderId, () => {
    anchorKey.value = null;
  });

  return {
    unifiedRows,
    anchorKey,
    setAnchorFromItem,
    computeShiftRange,
  };
};
